import { render, staticRenderFns } from "./ModalInquiryTransfer.vue?vue&type=template&id=7c127eab&"
import script from "./ModalInquiryTransfer.vue?vue&type=script&lang=js&"
export * from "./ModalInquiryTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ModalInquiryTransfer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports